import { useQuery } from '@tanstack/react-query';

import { useEmbedding } from '@/components/embed-provider';
import { policyHooks } from '@/features/policy/lib/policy-hooks';
import { usageApi } from '../lib/usage-api';

import { Card, CardContent } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { ActiveFlowsUsage } from './active-flows-usage';
import { TasksUsage } from './tasks-usage';
import { QuotaExhaustionInfo } from './quota-exhaustion-info';
import { UpgradeButton } from './upgrade-button';
import { UsagePlan } from './usage-plan';
import { UsageSkeleton } from './usage-skeleton';

export const UsageOverview = () => {
  const { embedState } = useEmbedding();

  const { data: usage, isLoading: isUsageLoading } = useQuery({
    queryKey: ['usage'],
    queryFn: () => usageApi.get(),
    refetchInterval: 180000,
  });

  const { data: policy, isLoading: isPolicyLoading } = policyHooks.usePolicy();

  const isLoading = isUsageLoading || isPolicyLoading;

  if (!isLoading && (!usage || !policy || policy.tier === 'no_access')) {
    return null;
  }

  return (
    <Card className="mx-2">
      <CardContent className="p-4">
        {isLoading || !usage || !policy ? (
          <UsageSkeleton />
        ) : (
          <div className="space-y-4">
            <UsagePlan policy={policy} />
            <Separator />
            <ActiveFlowsUsage usage={usage} policy={policy} />
            <TasksUsage usage={usage} policy={policy} />
            <QuotaExhaustionInfo
              usage={usage}
              quota={policy.monthlyTasksQuota}
            />
            {policy.tier === 'smart' && embedState.kizeoEmbed?.isActive && (
              <>
                <Separator />
                <UpgradeButton />
              </>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
